module.exports = __webpack_public_path__ + "img/payment-icon.27156f2d.svg";